import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Translate from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';
import SafeAnchor from '@hydra/common/components/SafeAnchor';
import CriteriumIconAndText from '@hydra/common/criterium/CriteriumIconAndText';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';

const useStyles = makeStyles(theme => ({
  text: {
    marginTop: theme.spacing(2)
  }
}));

const getContent = ({ url, messages = [] }) => {
  if (!url) {
    return <Translate content='criterium_description_robots_txt_bad' />;
  }

  if (messages.find(({ type }) => type === 'homepage')) {
    return <CriteriumIconAndText success={false} text={<Translate content='robots_txt_redirect_homepage' />} />;
  }

  return (
    <>
      <CriteriumIconAndText success text={<Translate content='robots_txt_found_at' />} />
      <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank'>{url}</SafeAnchor>
      {
        messages.find(({ type }) => type === 'pathDisallowed')
          ? <CriteriumIconAndText success={false} text={<Translate content='robots_txt_page_disallowed' />} />
          : <CriteriumIconAndText success text={<Translate content='robots_txt_page_allowed' />} />
      }
    </>
  );
};

export const RobotsTxt = ({ criterium }) => {
  const classes = useStyles();
  const { data, url } = criterium;
  const disallowedResources = data.disallowedResources || [];

  const getTable = (disallowedResources) => {
    const head = [
      <Translate content='robots_txt_url' key='robots_txt_url' />,
      <Translate content='robots_txt_type' key='robots_txt_type' />
    ];

    const rows = disallowedResources.map(({ url, type }) => {
      return [
        <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank' key={url}>{url}</SafeAnchor>,
        <Translate content={`robots_txt_type_${type}`} key='robots_txt_type' />
      ];
    });

    return (
      <>
        <div className={classes.text}>
          <CriteriumIconAndText success={false} text={<Translate content='robots_txt_disallowed_resources_text' />} />
        </div>
        <CriteriumTable head={head} rows={rows} fixedColumns={[80, 20]} nowrap striped />
      </>
    );
  };

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, url }}
    >
      {getContent(data)}
      {disallowedResources.length > 0 && getTable(disallowedResources)}
    </Criterium>
  );
};

RobotsTxt.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      url: PropTypes.string,
      messages: PropTypes.array,
      disallowedResources: PropTypes.array
    })
  })
};

export default React.memo(RobotsTxt);
